
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    PULS_INFO_REQUEST,
    PULS_FILES_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { pulsInfoResult, pulsFilesResult } from 'Redux/actions';


function* getCalampPulsInfo({ payload }) {
    try {

        const QUERY = `
            query getCalampPulsInfo ($esn: String!,$calampApi: enumCalampApi!, $pulsCustomerId: String) {
                result: getCalampPulsInfo (esn: $esn, calampApi: $calampApi, pulsCustomerId: $pulsCustomerId)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                ...payload,
                pulsCustomerId: "",
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(pulsInfoResult(data?.result))
        } else {
            yield put(pulsInfoResult({ error: true }))
        }

    } catch (exc) {
        yield put(pulsInfoResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/pulsInfoTab/redux/saga",
            "getCalampPulsInfo",
        )
    }
}

function* getCalampPulsFiles({ payload }) {
    try {

        const QUERY = `
            query getCalampDeviceFiles ($esn: String!,$current: Boolean!) {
                result: getCalampDeviceFiles (esn: $esn, current: $current)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                ...payload,
                pulsCustomerId: "",
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            let files = JSON.parse(data?.result)
            yield put(pulsFilesResult(files))
        } else {
            yield put(pulsFilesResult([]))
        }

    } catch (exc) {
        yield put(pulsFilesResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/pulsInfoTab/redux/saga",
            "getCalampPulsFiles",
        )
    }
}

function* watchMethods() {
    yield takeEvery(PULS_INFO_REQUEST, getCalampPulsInfo);
    yield takeEvery(PULS_FILES_REQUEST, getCalampPulsFiles);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}